import React from 'react'
import ReactDOM from 'react-dom'
import App from './pages/App'
import '@babel/polyfill'
import 'array-flat-polyfill'

if (
  window.location.protocol === 'http:' &&
  window.location.host.indexOf('test.simboss.com') === -1 && // 非测试
  process.env.NODE_ENV !== 'development' && // 非本地开发
  window.location.host.indexOf('.simboss.com') !== -1 // simboss 用户
) {
  window.location.href = window.location.href.replace('http:', 'https:')
}

ReactDOM.render(<App/>, document.getElementById('root'))
